const ContractPaper = (invoices) => {
  let htmlPrint = '';
  invoices.forEach((invoice) => {
    htmlPrint += `<div class="pagebreak">
      <div class="header">
        <div class="header-left"><b>${invoice.organization.toUpperCase()}</b></div>
        <div class="header-right">
          <div class="header-item"><span>Chỉ số mới:</span><span><b>${(
            invoice.energyEnd * 1
          ).toLocaleString('en-GB', {
            minimumFractionDigits: invoice.item?.decimalPoint || 0,
            maximumFractionDigits: invoice.item?.decimalPoint || 2,
          })}</b></span></div>
          <div class="header-item"><span>Chỉ số cũ:</span><span><b>${(
            invoice.energyBegin * 1
          ).toLocaleString('en-GB', {
            minimumFractionDigits: invoice.item?.decimalPoint || 0,
            maximumFractionDigits: invoice.item?.decimalPoint || 2,
          })}</b></span></div>
          <div class="header-item"><span>Điện tiêu thụ (${invoice.unitName}):</span><span><b>${(
      invoice.energy * 1
    ).toLocaleString('en-GB', {
      minimumFractionDigits: invoice.item?.decimalPoint || 0,
      maximumFractionDigits: invoice.item?.decimalPoint || 2,
    })}</b></span></div>
        </div>
      </div>
      <div class="content">
        <h3 class="invoice-title"> HÓA ĐƠN GIÁ TRỊ GIA TĂNG (TIỀN ĐIỆN)</h3>
        <p><b><u>TÌNH HÌNH SỬ DỤNG ĐIỆN:</u></b> ${
          invoice.device?.factory ? invoice.device.factory.name : ''
        }, ${invoice.device?.site ? invoice.device.site.name : ''}, ${invoice.deviceName}</p>
        <p>Kỳ hóa đơn Tháng ${invoice.month}(${invoice.dailyEnergy.length} ngày từ ngày ${
      invoice.startDate
    } đến ${invoice.endDate})</p>
        <p><b><u>TỔNG SỐ TIỀN THANH TOÁN:</u></b></p>
        <table>
          <thead>
            <tr>
              <th class="noBorderRight">Đơn giá</th>
              <th class="noBorderLeft">(${invoice.currency}/${invoice.unitName})</th>
              <th>Sản lượng(${invoice.unitName})</th>
              <th>THÀNH TIỀN(${invoice.currency})</th>
            </tr>
          </thead>
          <tbody>`;

    invoice.priceTable?.forEach((pt, index) => {
      if (pt.energy > 0) {
        htmlPrint += `<tr>
                <td class="noBorderRight center">Bậc ${index + 1}:</td>
                <td class="noBorderLeft center">${(pt.price * 1).toLocaleString('en-GB')}</td>
                <td>${(pt.energy * 1).toLocaleString('en-GB', {
                  minimumFractionDigits: invoice.item?.decimalPoint || 0,
                  maximumFractionDigits: invoice.item?.decimalPoint || 2,
                })}</td>
                <td>${Math.round(pt.amount * 1).toLocaleString('en-GB')}</td>
              </tr>`;
      }
    });

    htmlPrint += `
            <tr class="tableFooter">
              <td colspan="3" class="center">Tổng tiền điện chưa thuế (${invoice.currency})</td>
              <td>${Math.round(invoice.sum * 1).toLocaleString('en-GB')}</td>
            </tr>
            <tr class="tableFooter">
              <td colspan="3" class="center">Thuế GTGT(${invoice.currency})</td>
              <td>${Math.round(invoice.sum * 0.1).toLocaleString('en-GB')}</td>
            </tr>
            <tr class="tableFooter">
              <td colspan="3" class="center">Tổng cộng tiền thanh toán (${invoice.currency})</td>
              <td>${Math.round(invoice.sum * 1.1).toLocaleString('en-GB')}</td>
            </tr>
          </tbody>
        </table>
        <p><i>Bằng chữ: ${invoice.sumText} ${invoice.currency}.</i></p>
        <div class="footer">
          <div class="footer-left"></div>
          <div class="footer-right">
            <p><b>${invoice.organization}</b></p>
          </div>
        </div>
      </div>
    </div>`;
  });

  return htmlPrint;
};

export default ContractPaper;
